import { render, staticRenderFns } from "./CardInvestigationForTemplate.vue?vue&type=template&id=651a31e6"
import script from "./CardInvestigationForTemplate.vue?vue&type=script&lang=js"
export * from "./CardInvestigationForTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports